import { DEFAULT_BRAND_CONFIG } from "@/types/branding";

const { colors: dc } = DEFAULT_BRAND_CONFIG;

/** Builds setProperty calls referencing runtime vars `x` (colors) and `l` (logo URL). */
const APPLY_VARS = [
  `s.setProperty("--gail-color-primary",x.primary);`,
  `s.setProperty("--gail-color-secondary",x.secondary);`,
  `s.setProperty("--gail-color-tertiary",x.tertiary);`,
  `s.setProperty("--gail-text-color",x.textColor);`,
  `s.setProperty("--btn-primary-text-color",x.btnPrimaryText);`,
  `s.setProperty("--btn-secondary-text-color",x.btnSecondaryText);`,
  `s.setProperty("--btn-tertiary-text-color",x.btnTertiaryText);`,
  `s.setProperty("--gail-brand-primary",x.primary);`,
  `s.setProperty("--brand-logo-url",'url("'+l+'")');`,
  `x.primaryComplement?s.setProperty("--gail-color-primary-complement",x.primaryComplement):s.removeProperty("--gail-color-primary-complement");`,
  `x.secondaryComplement?s.setProperty("--gail-color-secondary-complement",x.secondaryComplement):s.removeProperty("--gail-color-secondary-complement");`,
].join("");

/** Default colors object literal embedded at build time. */
const DEFAULT_COLORS = [
  `{primary:"${dc.primary}"`,
  `secondary:"${dc.secondary}"`,
  `tertiary:"${dc.tertiary}"`,
  `textColor:"${dc.textColor}"`,
  `btnPrimaryText:"${dc.btnPrimaryText}"`,
  `btnSecondaryText:"${dc.btnSecondaryText}"`,
  `btnTertiaryText:"${dc.btnTertiaryText}"}`,
].join(",");

const DEFAULT_LOGO = `"${DEFAULT_BRAND_CONFIG.logoUrl}"`;

/**
 * Inline script that reads brand config from localStorage and applies CSS
 * variables before React hydrates, preventing a flash of the wrong brand.
 *
 * @param includeBrandReadyGate - When true, injects a `<style>` that hides the
 *   body until `.brand-ready` is added to `<html>` (used in the customers
 *   layout where React later confirms branding). When false, just applies CSS
 *   vars from cache if available.
 */
export function getBrandInlineScript(includeBrandReadyGate: boolean): string {
  if (!includeBrandReadyGate) {
    return [
      `(function(){try{`,
      `var b=localStorage.getItem("brand");if(!b)return;`,
      `var r=localStorage.getItem("brand_config_"+b);if(!r)return;`,
      `var c=JSON.parse(r);if(!c||!c.colors||c.key!==b)return;`,
      `var x=c.colors,l=c.logoUrl,h=document.documentElement;h.dataset.brand=b;var s=h.style;`,
      APPLY_VARS,
      `}catch(e){}})();`,
    ].join("");
  }

  // Gated: body starts hidden. Initialise with defaults, try to override from
  // localStorage, then apply once and mark brand-ready.
  return [
    `(function(){`,
    `var d=document,h=d.documentElement,st=d.createElement("style");`,
    `st.textContent="html:not(.brand-ready)>body{opacity:0;pointer-events:none}html.brand-ready>body{opacity:1;pointer-events:auto}";`,
    `d.head.appendChild(st);`,
    `var x=${DEFAULT_COLORS},l=${DEFAULT_LOGO};`,
    `try{`,
    `var b=localStorage.getItem("brand");`,
    `if(b){var r=localStorage.getItem("brand_config_"+b);`,
    `if(r){var c=JSON.parse(r);`,
    `if(c&&c.colors&&c.key===b){x=c.colors;l=c.logoUrl;h.dataset.brand=b}}}`,
    `}catch(e){}`,
    `var s=h.style;`,
    APPLY_VARS,
    `h.classList.add("brand-ready");`,
    `})();`,
  ].join("");
}
